import React from 'react';
import Thanks from 'components/page-thanks';

export default function ThanksPage() {
  return <Thanks />;
}
